import { render } from "./Spiner.vue?vue&type=template&id=17aaa16e"
import script from "./Spiner.vue?vue&type=script&lang=js"
export * from "./Spiner.vue?vue&type=script&lang=js"

import "./Spiner.vue?vue&type=style&index=0&id=17aaa16e&lang=css"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__